export const LOAD_PROVINCES_VEHICLE_BRAND_POSTAD = 'BookTestDrive/LOAD_PROVINCES_VEHICLE_BRAND_POSTAD';
export const FETCH_VEHICLE_MODEL_BOOK_TEST_DRIVE = 'BookTestDrive/FETCH_VEHICLE_MODEL_BOOK_TEST_DRIVE';
export const SUBMIT_BOOK_TEST_DRIVE_DATA = 'BookTestDrive/SUBMIT_BOOK_TEST_DRIVE_DATA';
export const SUBMIT_BOOK_TEST_DRIVE_DATA_FAILURE = 'BookTestDrive/SUBMIT_BOOK_TEST_DRIVE_DATA_FAILURE';
export const RESET_BOOK_TEST_DRIVE_OPTION = 'BookTestDrive/RESET_BOOK_TEST_DRIVE_OPTION';
export const REMOVE_MODEL_OPTIONS = 'BookTestDrive/REMOVE_MODEL_OPTIONS';
export const SET_LOADING = 'BookTestDrive/SET_LOADING';
export const LOAD_CITIES = 'BookTestDrive/LOAD_CITIES';